import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { createInitialDemoState, type DemoState } from "./demo-data";

interface DemoContextValue {
  state: DemoState;
  reset: () => void;
  readOnly: boolean;
}

const DemoContext = createContext<DemoContextValue | null>(null);

export function DemoProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<DemoState>(() => createInitialDemoState());

  const reset = useCallback(() => {
    setState(createInitialDemoState());
  }, []);

  const value = useMemo(
    () => ({
      state,
      reset,
      readOnly: true,
    }),
    [state, reset],
  );

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
}

export function useDemo() {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error("useDemo must be used within DemoProvider");
  return ctx;
}
